/**
 * Fallback when the account has configured NO break types: one generic
 * unpaid "Break". Never invent a menu of specific types here — the account's
 * configured list (Account → Time & Attendance → Break types) is the only
 * source of named types, and is_paid on a type drives net-hours/pay math,
 * so a hardcoded paid guess would silently change pay.
 * id is undefined; the backend creates an ad-hoc break from the name.
 */
export const DEFAULT_BREAK_TYPES = [{ name: 'Break', is_paid: false }];
